import { Component } from '@angular/core';
import { GlobalStoreService } from '../../../services/global-store/global-store.service';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { ErreurMappingService } from '../../../services/errors/erreur-mapping.service';
import { SaisieComponent } from '../saisie.component';
import { TypeChangementEnum } from '../../../constantes/type-changement.enum';
import { CybermetrieCoordonneesService } from '../../../services/cybermetrie/cybermetrie.service';
import { AccessibiliteService } from '../../../services/accessibilite.service';
import { LangueService } from 'src/app/services/langue/langue.service';

@Component({
  selector: 'app-saisie-courriel',
  templateUrl: './saisie-courriel.component.html',
  styleUrls: ['./saisie-courriel.component.scss'],
  standalone: false,
})
export class SaisieCourrielComponent extends SaisieComponent {
  constructor(
    erreurMapping: ErreurMappingService,
    globalStoreService: GlobalStoreService,
    navigationService: NavigationService,
    cybermetrieCoordonneesService: CybermetrieCoordonneesService,
    accessibiliteService: AccessibiliteService,
    languageService: LangueService
  ) {
    super(
      erreurMapping,
      globalStoreService,
      navigationService,
      cybermetrieCoordonneesService,
      accessibiliteService,
      languageService,
      TypeChangementEnum.COURRIEL
    );
  }
}
